"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Language = void 0;
var lodash_1 = require("lodash");
var Language = /** @class */function () {
  function Language(values) {
    if (values === void 0) {
      values = {};
    }
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, ['id', 'code', 'title', 'title_native', 'url', 'domain_switch_description']));
  }
  return Language;
}();
exports.Language = Language;
